module.exports = __webpack_public_path__ + "img/safsal_no.8488822d.png";